import { ALTERAR_REGISTROS_POR_PAGINA_MDFE } from '../../actions/types'

export default function reducerRegistrosPorPaginaMdfe(state = 10, action = undefined) {
  switch (action.type) {
    case ALTERAR_REGISTROS_POR_PAGINA_MDFE: {
      return action.payload
    }
    default:
      return state
  }
}
